import React from 'react';
import ImageNew from '../../assets/images/3new.jfif';
import Image5 from '../../assets/images/5.jpeg';
import Image6 from '../../assets/images/6.jpeg';
import Image11 from '../../assets/images/11.jpeg';
import Image1 from '../../assets/images/1.jpeg';
import MyMapComponent from "../../components/map/map";
import SectionHeader from "../../components/ui/SectionHeader";
import TestimonialCard from "../../components/ui/TestimonialCard";
import FaqSection from "../../components/ui/FaqSection";

const testimonials = [
    {
        name: "Jan P.",
        text: "Po pouhém jediném setkání mi Šimon pomohl odstranit nejméně půlroční a opravdu neústupné bolesti v oblasti tricepsu. Byl jsem obrovsky limitován ve sportu a nemohl jsem se kvůli mého zranění zapojit s celým týmem do zimní přípravy a musel jsem tak pouze rehabilitovat. Šimona, který mi byl doporučen již několikrát v minulosti jsem tehdy navštívil. Po důkladné prohlídce okamžitě zjistil kde je problém. Pomocí Šimonových cviků a rad se mi konečně podařilo bolest kompletně odstranit a můžu se tak konečně dále plně rozvíjet s celým týmem. Za tu dobu jsem byl u dosti odborníků a lékařů, ale nikdo mi nepomohl tak jako právě Šimon. Vřele a naprosto jistě mohu Šimonovy služby doporučit každému s jakýmkoliv problémem.",
    },
    {
        name: "Zuzana Ch.",
        text: "Chodíme k panu Urbanovi s dospívajícím synem, který rychleji vyrostl a začal se hrbit, zároveň má ploché nohy. Chceme předejít možným zdravotním potížím v dospělosti. Syn začal pravidelně cvičit, chápe, že náprava nepřijde hned, ale fyzioterapeut ho dokázal správně motivovat. Shodou okolností jsme se synem absolvovali preventivní prohlídku a paní doktorka ho pochválila, že má mnohem lepší držení těla a poznala, že na sobě pracuje. Takže děkujeme a doporučujeme :)",
    },
    {
        name: "Jiří R.",
        text: "Moje první návštěva a velká spokojenost – sympatický a profesionální fyzioterapeut, čisté a moderní prostředí. Vše mi trpělivě vysvětlil, ukázal cviky na doma a díky online rezervaci je objednání opravdu jednoduché. Určitě doporučuji.",
    },
    {
        name: "Lucie S.",
        text: "Pan Urban je velmi šikovný a své práci perfektně rozumí. Několikrát mi moc pomohl, věřím mu a vřele jeho služby doporučuji. Není to ale kouzelník, pokud chcete vidět výsledky, musíte být připraveni pro to něco udělat a musíte poctivě cvičit. 😉",
    },
];

const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=UrbanFyzio+Fr%C3%BDdek-M%C3%ADstek";


const AboutSection = () => {
    return (
        <div className="w-full py-16 md:py-24 space-y-20 md:space-y-28">

            {/* Intro */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
                <div className="space-y-8">
                    <div>
                        <SectionHeader
                            eyebrow="O mně"
                            title="O UrbanFyzio"
                            description="V UrbanFyzio se soustředím na to, co vás přivedlo. Společně najdeme příčinu bolesti, vyzkouším techniky, které opravdu fungují, a naučím vás, jak si pomoct i mimo ordinaci. Žádné šablonové cvičení — terapie je vždy podle vašeho stavu a cílů."
                        />
                    </div>
                    <div>
                        <h3 className="text-2xl md:text-3xl font-semibold text-ink-900 mb-3">Můj přístup</h3>
                        <p className="text-ink-600 text-base md:text-lg leading-relaxed">
                            Kineziologický rozbor → cílená manuální terapie → cvičení, které si vezmete domů.
                            Pracuji se sportovci, rodiči s dětmi i s klienty po úrazech a operacích.
                        </p>
                    </div>
                </div>
                <div className="relative">
                    <div className="absolute -inset-3 bg-brand-100 rounded-3xl -z-0 rotate-1" />
                    <img
                        src={ImageNew}
                        alt="Interiér fyzioterapeutické ambulance UrbanFyzio ve Frýdku-Místku"
                        loading="lazy"
                        className="relative z-10 w-full aspect-[4/5] object-cover rounded-2xl shadow-soft-lg"
                    />
                </div>
            </div>

            {/* Gallery */}
            <div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
                    {[Image5, Image6, Image11, Image1].map((src, i) => (
                        <div key={i} className="overflow-hidden rounded-2xl shadow-soft group">
                            <img
                                src={src}
                                alt={`Fyzioterapeutická ambulance UrbanFyzio — pohled ${i + 1}`}
                                loading="lazy"
                                className="w-full aspect-square object-cover transition-transform duration-500 ease-smooth group-hover:scale-105"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Testimonials */}
            <div>
                <div className="text-center mb-12">
                    <span className="badge-brand mb-3">Reference</span>
                    <h3 className="text-3xl md:text-4xl font-bold text-ink-900">Co o mně říkají klienti</h3>
                    <div className="mt-4 flex justify-center"><span className="accent-bar" /></div>
                    <div className="mt-5 inline-flex items-center gap-2 text-ink-600">
                        <div className="flex items-center gap-0.5 text-amber-400">
                            {[0,1,2,3,4].map(i => (
                                <svg key={i} className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                            ))}
                        </div>
                        <span className="font-semibold text-ink-800">5,0</span>
                        <span>· Hodnocení na Google</span>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
                    {testimonials.map((t) => (
                        <TestimonialCard key={t.name} name={t.name} text={t.text} />
                    ))}
                </div>
                <div className="mt-10 text-center">
                    <a
                        href={GOOGLE_REVIEWS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-outline"
                    >
                        Více recenzí na Google
                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                            <polyline points="15 3 21 3 21 9" />
                            <line x1="10" y1="14" x2="21" y2="3" />
                        </svg>
                    </a>
                </div>
            </div>

            {/* FAQ */}
            <FaqSection />

            {/* Contact CTA */}
            <div className="card p-8 md:p-12 bg-soft-sky">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    <div>
                        <span className="badge-brand mb-4">Volné termíny</span>
                        <h3 className="text-3xl md:text-4xl font-bold text-ink-900 leading-tight">
                            Máme volné termíny.
                        </h3>
                        <p className="mt-4 text-ink-600 text-base md:text-lg">
                            Stačí napsat nebo zavolat — ozvu se zpět a domluvíme čas, který vám vyhovuje.
                        </p>
                        <div className="mt-6 flex flex-col sm:flex-row gap-3">
                            <a
                                href="https://urbanfyzio.reservio.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-primary"
                            >
                                Rezervovat online
                            </a>
                            <a href="tel:+420734312843" className="btn-outline">
                                +420 734 312 843
                            </a>
                        </div>
                    </div>
                    <div className="space-y-4">
                        <InfoRow
                            label="Adresa"
                            value="Palackého 131, Frýdek-Místek"
                            icon={
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                    <circle cx="12" cy="10" r="3" />
                                </svg>
                            }
                        />
                        <InfoRow
                            label="Telefon"
                            value="+420 734 312 843"
                            icon={
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
                                </svg>
                            }
                        />
                        <InfoRow
                            label="Email"
                            value="info@urbanfyzio.cz"
                            icon={
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                </svg>
                            }
                        />
                    </div>
                </div>
            </div>

            {/* Map */}
            <div className="overflow-hidden rounded-2xl shadow-soft-lg border border-ink-100">
                <MyMapComponent center={[49.67464065551758, 18.343393325805664]} zoom={25} />
            </div>

        </div>
    );
};

const InfoRow = ({ label, value, icon }) => (
    <div className="flex items-start gap-4 p-4 rounded-xl bg-white border border-ink-100">
        <div className="w-10 h-10 rounded-lg bg-brand-50 text-brand-600 flex items-center justify-center flex-shrink-0">
            <span className="w-5 h-5 inline-flex">{icon}</span>
        </div>
        <div className="min-w-0">
            <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold">{label}</div>
            <div className="text-ink-900 font-medium break-words">{value}</div>
        </div>
    </div>
);

export default AboutSection;
